import { render, staticRenderFns } from "./ListingColumnsList.vue?vue&type=template&id=f365dbdc&scoped=true"
import script from "./ListingColumnsList.vue?vue&type=script&lang=js"
export * from "./ListingColumnsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f365dbdc",
  null
  
)

export default component.exports